import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {
  ArticleWizardCreateForm,
  ArticleWizardForm,
  ArticleWizardFormTemplate,
  ArticleWizardUpdateForm,
} from './article-wizard.models';
import type {UseQueryResult} from '@tanstack/react-query';
import {useQuery} from '@tanstack/react-query';

export class ArticleWizardAxiosService {
  public static get(oaSdsNr: string, version?: number): Promise<ArticleWizardForm> {
    return AxiosHttpClient.get<ArticleWizardForm>(
      `${environment.apiv4uri}wizard/article/${oaSdsNr}${(version ?? null) === null ? '' : `/${version}`}`);
  }

  public static create(form: ArticleWizardCreateForm): Promise<ArticleWizardForm> {
    return AxiosHttpClient.post<ArticleWizardForm>(`${environment.apiv4uri}wizard/article`, form);
  }

  public static save(form: ArticleWizardUpdateForm): Promise<ArticleWizardForm> {
    return AxiosHttpClient.put<ArticleWizardForm>(`${environment.apiv4uri}wizard/article/save`, form);
  }

  public static transfer(form: ArticleWizardUpdateForm): Promise<ArticleWizardForm> {
    return AxiosHttpClient.put<ArticleWizardForm>(`${environment.apiv4uri}wizard/article/transfer`, form);
  }

  public static getTemplate(workType: number): Promise<ArticleWizardFormTemplate> {
    return AxiosHttpClient.get<ArticleWizardFormTemplate>(
      `${environment.apiv4uri}wizard/article/template/${workType}`,
    );
  }

  public static useArticleWizardForm(oaSdsNr: string, version: number | null): UseQueryResult<ArticleWizardForm> {
    return useQuery({
      queryKey: ['oaSdsNr', oaSdsNr, 'version', version],
      retry: false,
      refetchOnWindowFocus: false,
      queryFn: () => ArticleWizardAxiosService.get(oaSdsNr, version),
      enabled: oaSdsNr !== null,
    });
  };

  public static useArticleWizardFormTemplate(workType: number | null): UseQueryResult<ArticleWizardFormTemplate> {
    return useQuery({
      queryKey: ['workType', workType],
      retry: false,
      refetchOnWindowFocus: false,
      queryFn: () => ArticleWizardAxiosService.getTemplate(workType),
      enabled: workType !== null,
    });
  };
}
